[
  {
    "code": "VI-SC",
    "name": "Saint Croix"
  },
  {
    "code": "VI-SJ",
    "name": "Saint John"
  },
  {
    "code": "VI-ST",
    "name": "Saint Thomas"
  }
]